import { render, staticRenderFns } from "./MemberProductRelation.vue?vue&type=template&id=0fb10609&scoped=true&"
import script from "./MemberProductRelation.vue?vue&type=script&lang=js&"
export * from "./MemberProductRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb10609",
  null
  
)

component.options.__file = "MemberProductRelation.vue"
export default component.exports